module.exports = __webpack_public_path__ + "static/assets/5b8017a3c693ce74a3aa4e07f08d93d1.png";